import React from 'react'

const SubHeader = ({ children }) => (
  <div className='flex items-center px2 border-bottom bc-gray-lighter bg-white-85'>
    {children}
  </div>
)

export default SubHeader
